/** @format */

import { TRoom } from '@/@ducks/room/declarations';
import CardRoom from '@/components/page/PageListing/components/CardRoom';
import { PopupAnchor, PopupPosition } from '@/ducks/map/hooks/useMap';
import React, { useMemo } from 'react';
import { Popup } from 'react-map-gl';
import { PopupContent } from './MapPopup.style';

interface MapPopupProps {
  popupInfo: TRoom;
  getPopupAnchor: (latitude: number, longitude: number) => PopupAnchor;
  setPopupInfo: React.Dispatch<React.SetStateAction<TRoom | null>>;
}

const MapPopup: React.FC<MapPopupProps> = ({ getPopupAnchor, popupInfo, setPopupInfo }) => {
  const { position, verticalOffset } = useMemo(
    () => getPopupAnchor(popupInfo.position.latitude, popupInfo.position.longitude),
    [getPopupAnchor, popupInfo.position.latitude, popupInfo.position.longitude],
  );

  const offset: [number, number] = useMemo(() => {
    const yOffset: number = verticalOffset ?? 25;
    const offsets: Record<PopupPosition, [number, number]> = {
      center: [0, yOffset],
      left: [50, yOffset],
      right: [-50, yOffset],
      top: [0, 25],
      bottom: [0, -yOffset],
      'top-left': [25, 0],
      'top-right': [25, 0],
      'bottom-left': [50, 0],
      'bottom-right': [-50, 0],
    };

    return offsets[position] || [0, 25];
  }, [position, verticalOffset]);

  return (
    <Popup
      maxWidth={'20.5rem'}
      anchor={position}
      longitude={Number(popupInfo.position.longitude)}
      latitude={Number(popupInfo.position.latitude)}
      onClose={() => setPopupInfo(null)}
      offset={offset}
    >
      <PopupContent>
        <CardRoom room={popupInfo} isPopup />
      </PopupContent>
    </Popup>
  );
};

export default MapPopup;
